import PropTypes from 'prop-types';
import React from 'react';

import {reduxForm} from 'redux-form'
import {connect} from 'react-redux'

import AddressForm from '../../components/forms/AddressForm'

import * as ColumnSizes from '../../components/Column'

import {validateTradePartnerSimpleForm as validate} from '../../util/validate'
import {getRecommendedAccountTypes} from "../../selectors/SimpleSelectors";

function ContractPartnerSimpleForm(props) {
    return (
        <AddressForm
            showTaxID={true}
            showRecommendedAccount={false}
            showNote={false}
            showTitle={false}
            forceValidation={props.forceValidation}
            recommendedAccountTypes={[]}
            defaultColumnSize={ColumnSizes.SIZE_50}
            optionals={props.optionals}
            defaultWrapperSize={ColumnSizes.SIZE_100}
        />
    );
}

ContractPartnerSimpleForm.propTypes = {
    forceValidation: PropTypes.bool,
    optionals: PropTypes.array
};

ContractPartnerSimpleForm.defaultProps = {
    forceValidation: false,
    optionals: ["note", "title", "vat", "phone"]
};

const mapStateToProps = (state, ownProps) => {

    return {
        recommendedAccountTypes: getRecommendedAccountTypes(state)
    }

}

ContractPartnerSimpleForm = reduxForm({form: 'contractPartner', destroyOnUnmount: false, validate})(ContractPartnerSimpleForm)// eslint-disable-line

ContractPartnerSimpleForm = connect(mapStateToProps)(ContractPartnerSimpleForm)// eslint-disable-line

export default ContractPartnerSimpleForm


/** WEBPACK FOOTER **
 ** ./src/containers/clientdatasimple/ContractPartnerSimpleForm.js
 **/